export default {
  // Splash
  appName: "طلبات الجملة والتجزئة",
  
  // Auth
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  name: "الاسم",
  phone: "رقم الجوال",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  confirmPassword: "تأكيد كلمة المرور",
  retailCustomer: "عميل تجزئة",
  wholesaleTrader: "تاجر جملة",
  selectAccountType: "اختر نوع الحساب",
  verifyOTP: "تفعيل الحساب",
  enterOTP: "أدخل رمز التفعيل",
  verify: "تفعيل",
  
  // Home
  home: "الرئيسية",
  categories: "الأقسام",
  offers: "العروض",
  groceries: "بقالات",
  beverages: "مشروبات",
  cleaningProducts: "منظفات",
  frozenProducts: "منتجات مجمدة",
  wholesaleOffers: "عروض الجملة",
  search: "ابحث عن منتج...",
  
  // Products
  products: "المنتجات",
  newProducts: "جديد",
  bestSelling: "الأكثر مبيعًا",
  filterBy: "تصفية حسب",
  price: "السعر",
  available: "متوفر",
  outOfStock: "غير متوفر",
  addToCart: "أضف للسلة",
  sar: "ر.س",
  
  // Cart
  cart: "السلة",
  emptyCart: "السلة فارغة",
  total: "الإجمالي",
  deliveryFee: "رسوم التوصيل",
  deliveryTime: "وقت التوصيل",
  confirmOrder: "تأكيد الطلب",
  
  // Address
  deliveryAddress: "عنوان التوصيل",
  selectLocation: "حدد الموقع",
  enterAddress: "أدخل العنوان يدويًا",
  immediate: "فوري",
  scheduled: "مجدول",
  
  // Quotes
  priceQuotes: "عروض الأسعار",
  waitingForQuotes: "جاري استلام العروض...",
  selectOffer: "اختر العرض",
  
  // Payment
  payment: "الدفع",
  mada: "مدى",
  visa: "فيزا",
  applePay: "Apple Pay",
  cashOnDelivery: "الدفع عند الاستلام",
  payNow: "ادفع الآن",
  paymentSuccess: "تم الدفع بنجاح",
  
  // Tracking
  orderTracking: "متابعة الطلب",
  orderReceived: "تم الاستلام",
  preparing: "قيد التجهيز",
  readyForDelivery: "جاهز للتوصيل",
  onTheWay: "في الطريق",
  delivered: "تم التسليم",
  
  // Rating
  rateExperience: "قيّم تجربتك",
  rateDriver: "تقييم المندوب",
  rateProvider: "تقييم مقدم الخدمة",
  addComment: "أضف تعليق",
  submit: "إرسال",
  
  // Orders
  orders: "الطلبات",
  currentOrders: "الطلبات الحالية",
  completedOrders: "الطلبات المكتملة",
  cancelledOrders: "الطلبات الملغية",
  orderDetails: "تفاصيل الطلب",
  
  // Profile
  profile: "الحساب",
  editProfile: "تعديل البيانات",
  addresses: "العناوين",
  paymentMethods: "طرق الدفع",
  settings: "الإعدادات",
  language: "اللغة",
  darkMode: "الوضع الليلي",
  logout: "تسجيل الخروج",
  
  // Wholesale
  wholesale: "الجملة",
  bulkOrders: "طلبات الجملة",
  minimumQuantity: "الحد الأدنى",
  selectQuantity: "اختر الكمية",
  
  // Common
  back: "رجوع",
  next: "التالي",
  cancel: "إلغاء",
  save: "حفظ",
  edit: "تعديل",
  delete: "حذف",
  quantity: "الكمية",
  description: "الوصف",
  details: "التفاصيل",
};